import React from 'react';
import { whyChooseUs } from '../mockData';

const WhyChooseUs = () => {
  return (
    <section id="about" className="py-16 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* About Us Section */}
        <div className="mb-16">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-8 text-center">
            About Greva Electric
          </h2>
          <div className="max-w-4xl mx-auto">
            <h3 className="text-2xl md:text-3xl font-bold text-gray-900 mb-6 text-center">
              Meet Greva Electric: Quality Electricians Serving Saskatoon, SK and The Surrounding Areas
            </h3>
            <p className="text-lg text-gray-700 mb-6 leading-relaxed">
              At Greva Electric, we were founded on a promise to deliver exceptional quality work with a personal 
              touch. Serving the vibrant community of Saskatoon, we treat homeowners and business owners like 
              neighbours, ensuring every electrical installation and repairs are handled with expert care. As a 
              locally owned and owner-operated company, we pride ourselves on putting our clients first and building 
              long-lasting relationships through reliable and friendly service.
            </p>
            <p className="text-lg text-gray-700 leading-relaxed">
              Our services include <strong>Electrical Remodelling, EV Charger Installation, Electrical Repairs, 
              Lighting Installation, Electrical Panel Upgrades, Fire alarm testing and maintenance, Generator 
              Installation, Building & Pylon Signage Repair, Maintenance and Troubleshooting, and Security Camera 
              & Data Wiring</strong>. Learn More about our services and why we should be your trusted partner for 
              your electrical needs!
            </p>
          </div>
        </div>

        {/* Why Choose Us Section */}
        <div>
          <h3 className="text-3xl font-bold text-center text-gray-900 mb-12">Why Choose Us?</h3>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
            {whyChooseUs.map((item) => (
              <div key={item.id} className="bg-gray-50 rounded-lg p-8 shadow-md hover:shadow-lg transition-shadow">
                <h4 className="text-2xl font-bold text-gray-900 mb-4">{item.title}</h4>
                <p className="text-gray-700 leading-relaxed">{item.description}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default WhyChooseUs;